import { uuid } from './regex';

export const DigitalSigningRoutes = {
    path: 'contract',
    details: {
        path: `:contractId(${uuid})`,
    },
    explain: {
        path: 'explain',
    },
};
